<ng-container *transloco="let translate">
  <div class="px-30" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around start">
    <div fxFlex="100" fxLayoutAlign="space-between" class="py-10">
      <form [formGroup]="filterForm" fxFlex="100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button (click)="addOrUpdateFilter()" egButton egType="round" type="button" egButtonSize="small">
          <div fxLayoutAlign="center center">
            <img src="/assets/icons/field_plus.svg" class="svg-to-white" alt="ADD" />
            {{ translate('support.quickFilter.addNewFilter') }}
          </div>
        </button>
        <eg-checkbox formControlName="active" fxFlex="10" class="mt-5" [label]="translate('support.quickFilter.active')"></eg-checkbox>
        <eg-select
          fxFlex="10"
          [items]="limitOptions"
          formControlName="limit"
          [label]="translate('support.quickFilter.limit')"
          [placeholder]="translate('support.quickFilter.limit')"
        ></eg-select>
      </form>
      <button (click)="onReset()" class="form-reset-button" egButton egStyle="secondary" egType="round" type="reset" egButtonSize="small">
        {{ translate('support.button.reset') }}
      </button>
    </div>
  </div>
</ng-container>
